import React from 'react';
import { SelectionGroup, SelectionGroupItem, Tooltip } from 'fronton-react';
import { useFormContext } from 'react-hook-form';
import { ColourCircle, ColourWhite } from 'assets';
import { colourLabels, iconColors } from '../../../const';
import { ColourType, ParametersEnum, TGetIcon } from '../../../types';
import { getNextValueMultiChoice } from '../../../helpers/get-selection-group-next-value';
import { IconContainer, SelectionGroupClassname, SelectionGroupItemClassname } from '../styles';

const colours = [
  {
    name: ColourType.WHITE,
    label: colourLabels.WHITE,
    getIcon: ({ isSmall }: TGetIcon) => (isSmall ? <ColourWhite isMobile /> : <ColourWhite />),
  },
  {
    name: ColourType.SILVER,
    label: colourLabels.SILVER,
    getIcon: ({ isSmall }: TGetIcon) =>
      isSmall ? (
        /* иконка по факту такая же,
         но т.к. у нас 2 варианта для адаптива на SSR,
         то через флаг мы делаем внутренние элементы svg уникальными */
        <ColourCircle color={iconColors.SILVER} isMobile />
      ) : (
        <ColourCircle color={iconColors.SILVER} />
      ),
  },
  {
    name: ColourType.BEIGE,
    label: colourLabels.BEIGE,
    getIcon: ({ isSmall }: TGetIcon) =>
      isSmall ? (
        <ColourCircle color={iconColors.BEIGE} isMobile />
      ) : (
        <ColourCircle color={iconColors.BEIGE} />
      ),
  },
  {
    name: ColourType.BROWN,
    label: colourLabels.BROWN,
    getIcon: ({ isSmall }: TGetIcon) =>
      isSmall ? (
        <ColourCircle color={iconColors.BROWN} isMobile />
      ) : (
        <ColourCircle color={iconColors.BROWN} />
      ),
  },
  {
    name: ColourType.BLACK,
    label: colourLabels.BLACK,
    getIcon: ({ isSmall }: TGetIcon) =>
      isSmall ? (
        <ColourCircle color={iconColors.BLACK} isMobile />
      ) : (
        <ColourCircle color={iconColors.BLACK} />
      ),
  },
  {
    name: ColourType.YELLOW,
    label: colourLabels.YELLOW,
    getIcon: ({ isSmall }: TGetIcon) =>
      isSmall ? (
        <ColourCircle color={iconColors.YELLOW} useTwoColors={false} isMobile />
      ) : (
        <ColourCircle color={iconColors.YELLOW} useTwoColors={false} />
      ),
  },
  {
    name: ColourType.GREEN,
    label: colourLabels.GREEN,
    getIcon: ({ isSmall }: TGetIcon) =>
      isSmall ? (
        <ColourCircle color={iconColors.GREEN} isMobile />
      ) : (
        <ColourCircle color={iconColors.GREEN} />
      ),
  },
];

type TProps = {
  value: ColourType[];
  onChange: (...event: unknown[]) => void;
  mobile: boolean;
};

export const AdaptiveSelectionGroup = ({ value, onChange, mobile }: TProps) => {
  const { setValue } = useFormContext();

  return (
    <SelectionGroup
      active={value}
      onChange={(_, colourValue) => {
        onChange();
        setValue(
          ParametersEnum.colour,
          getNextValueMultiChoice({ clickedValue: colourValue, currentValue: value })
        );
      }}
      variant="pseudo"
      size={mobile ? 's' : 'm'}
      rounded
      className={SelectionGroupClassname}>
      {colours.map(colourItem => (
        <Tooltip key={colourItem.name} placement="top" title={colourItem.label}>
          <IconContainer>
            <SelectionGroupItem
              value={colourItem.name}
              iconOnly
              className={SelectionGroupItemClassname}
              data-testid={`${colourItem.name}-colour-select`}>
              {colourItem.getIcon({ isSmall: mobile })}
            </SelectionGroupItem>
          </IconContainer>
        </Tooltip>
      ))}
    </SelectionGroup>
  );
};
